<template>
  <div>
    <label
      class="block mb-2 text-sm font-medium text-slate-700 dark:text-slate-300"
    >
      {{ label }}
    </label>

    <p v-if="hint" class="mb-2 text-xs text-slate-500 dark:text-slate-400">
      {{ hint }}
    </p>

    <textarea
      :placeholder="placeholder"
      :rows="rows"
      class="w-full px-3 py-2 bg-white border rounded-lg resize-none dark:bg-slate-900 focus:outline-none focus:ring-2 border-primary/30 focus:ring-primary/40 text-slate-800 dark:text-slate-100 placeholder-slate-400"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>

    <p v-if="error" class="mt-1 text-xs text-red-600">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "BaseTextarea",
  props: {
    modelValue: [String, Number],
    label: String,
    placeholder: String,
    hint: String, 
    error: String,
    rows: { type: [String, Number], default: 3 },
  },
  emits: ["update:modelValue"],
};
</script>
